import { StatCard } from '@/components/staking/StatCard'
import { YourStakeCard } from '@/components/staking/YourStakeCard'
import { StakeBecyCard } from '@/components/staking/StakeBecyCard'
import { Footer } from '@/components/layout/footer'
import { PageShell } from '@/components/layout/PageShell'

export default function Staking() {
	return (
		<PageShell footer={<Footer />}>
			<div className='grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5'>
				<StatCard title='Total BECY Staked' value='$ 54 054' decimals='.24' percent='2.6%' trend='up' />
				<StatCard title='Total User Staked' value='$ 8 561 051' decimals='.75' percent='24%' trend='up' />
				<StatCard title='Staking Volume' value='$ 15 500' decimals='.47' percent='0.4%' trend='down' />
				<StatCard title='BECY Price' value='$ 38' decimals='.28' percent='18.2%' trend='up' />
				<StatCard title='Current APY' value='7.56%' highlight />
			</div>

			<div className='grid grid-cols-1 gap-4 xl:grid-cols-2'>
				<YourStakeCard />
				<StakeBecyCard />
			</div>
		</PageShell>
	)
}
